import { Component, Input } from '@angular/core';

@Component({
  selector: 'adc-list',
  templateUrl: './adc-list.component.html',
  styleUrls: ['./adc-list.component.scss'],
  standalone: false
})
export class AdcListComponent {
  @Input('data') data: any;
  @Input("type") type: string = '';
}
